import {
  WEBSITE,
  WEBSITE_NAME,
  WEBSITE_URL,
  WEBSITE_BIO,
  WEBSITE_TEMPLATE
}
from '../constants';

export const setWebsite = (text) => ({ type: WEBSITE, payload: text })
export const setWebsiteurl = (text) => ({ type: WEBSITE_URL, payload: text })
export const setWebsitename = (text) => ({ type: WEBSITE_NAME, payload: text })
export const setWebsiteBio = (text) => ({ type: WEBSITE_BIO, payload: text })
export const selectTemplate = (text) => ({ type: WEBSITE_TEMPLATE, payload: text })